import { Column } from "pages/setting/components/Modal.styled";

export const AdminLeaveNotice = () => {
  return (
    <Column style={{ flexGrow: "1" }}>
      <div style={{ wordBreak: "keep-all" }}>
        그동안 작성하신 게시물은 총학생회원들의 정상적인 이용을 위하여 삭제되지
        않으며, 오로지 회원님의 한동대학교 총학생회 관리자 홈페이지에 대한 접근
        권한만 삭제됩니다.
        <br />
        <br />* 한동대학교 총학생회 사이트에 대한 탈퇴를 원하실 경우,
        사이트(도메인주소) 하단에서 회원 탈퇴를 신청해 주세요.
      </div>
    </Column>
  );
};
